import React, { useState, useEffect } from "react";

const isMap = (obj) => obj instanceof Map;
const formatDateForDisplay = (date) => {
    const formattedDate = ("0" + date.getDate()).slice(-2);
    const formattedMonth = ("0" + (date.getMonth() + 1)).slice(-2);
    const formattedYear = date.getFullYear();
    return `${formattedDate}-${formattedMonth}-${formattedYear}`;
};
const skipable = (present, totalClasses, crit) => {
    let tc = totalClasses;
    let pc = present
    let toreturn = 0;
    if ((present / tc) * 100 >= crit) {
        while ((present / (tc + 1)) * 100 >= crit) {
            toreturn++;
            tc++;
        }
    } else {
        while ((pc / (tc)) * 100 < crit) {
            toreturn++;
            tc++;
            pc++;
        }
    }
    return toreturn;
};

const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const calculateAttendance = (subjects, schedule, attendance, referenceDate) => {
    const result = {};

    const filteredAttendance = isMap(attendance)
        ? [...attendance.entries()].filter(([date, _]) => new Date(date) > new Date(referenceDate))
        : Object.entries(attendance).filter(([date, _]) => new Date(date) > new Date(referenceDate));

    Object.entries(subjects).map(([subjectId, subjectName]) => {
        let totalClasses = 0;
        let presentCount = 0;
        let absentCount = 0;
        let today = new Date();
        today = formatDateForDisplay(today);
        const startDateObj = new Date(referenceDate.split('-').reverse().join('-')); // Convert "DD-MM-YYYY" to "YYYY-MM-DD"
        const endDateObj = new Date(today.split('-').reverse().join('-'));
        let currentDate = new Date(startDateObj);
        while (currentDate <= endDateObj) {
            const subjectList = schedule[daysOfWeek[currentDate.getDay()]];
            if (subjectList && subjectList.includes(subjectId)) {

                if (attendance[formatDateForDisplay(currentDate)] && attendance[formatDateForDisplay(currentDate)][subjectId] && attendance[formatDateForDisplay(currentDate)][subjectId] === 'Absent') {
                    absentCount++;
                    totalClasses++;
                } else if (attendance[formatDateForDisplay(currentDate)] && attendance[formatDateForDisplay(currentDate)][subjectId] && attendance[formatDateForDisplay(currentDate)][subjectId] === 'Cancel') {
                } else {
                    totalClasses++;
                    presentCount++;
                }

            }
            currentDate.setDate(currentDate.getDate() + 1);  // Increment the day by 1
        }
        result[subjectId] = {
            name: subjectName,
            totalClasses: totalClasses,
            present: presentCount,
            absent: absentCount
        };

    });
    return result;

};
export default function AtdDetail({ sesInfo, setsesInfo }) {
    const [attendanceData, setAttendanceData] = useState(null);
    useEffect(() => {
        const referenceDate = sesInfo.sesDet.sesStart; // Reference date
        const calculatedData = calculateAttendance(sesInfo.sesData.subjects, sesInfo.sesData.schedule, sesInfo.sesData.attendance, referenceDate);
        setAttendanceData(calculatedData);
    }, []);
    if (!attendanceData) return <div>Loading...</div>;
    const crit = 75;

    return (
        <div className="mt-4 p-5 rounded-lg bg-slate-50 w-full">
            <div className="max-w-3xl mx-auto bg-slate-50 rounded-md">
                <h2 className="text-md bg-slate-100 rounded-lg px-2 py-1 mb-3 font-semibold text-gray-800">Attendance Summary </h2>
                {Object.keys(attendanceData).map((subjectId) => {
                    const { name, totalClasses, present, absent } = attendanceData[subjectId];
                    return (
                        <div key={subjectId} class="px-4 py-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
                            <span class="text-gray-600 ml-1 font-bold">{name}</span>
                            <div class="flex items-start justify-between">
                                <div class="flex flex-col">

                                    <table class="min-w-full table-auto mt-2 bg-white rounded-lg text-sm">
                                        <tbody class="text-gray-700">
                                            <tr class="">
                                                <td class="px-2">Total : </td>
                                                <td class="px-2">{totalClasses}</td>
                                            </tr>
                                            <tr class="">
                                                <td class="px-2">Present : </td>
                                                <td class="px-2">{present}</td>
                                            </tr>
                                            <tr class="">
                                                <td class="px-2">Absent : </td>
                                                <td class="px-2">{absent}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="bg-gray-100 rounded-md">
                                    <div className="relative w-20 h-20">
                                        <svg className="absolute top-0 left-0" style={{ transform: "rotate(270deg)" }} width="100%" height="100%" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                                            {/* Outer Circle (Background Circle) */}
                                            <circle className="text-gray-200" cx="18" cy="18" r={12} strokeWidth="2" fill="none" />
                                            {/* Inner Circle (Progress Circle) */}
                                            <circle
                                                stroke={(present / totalClasses >= crit/100)? ("green") : ("red")}
                                                cx="18"
                                                cy="18"
                                                r={12}
                                                strokeWidth="2"
                                                fill="none"
                                                strokeDasharray={2 * Math.PI * 12}
                                                strokeDashoffset={(2 * Math.PI * 12) - ((totalClasses !== 0 ? (present / totalClasses) : (1))) * 2 * Math.PI * 12}
                                            />
                                        </svg>
                                        <div className="text-xs absolute inset-0 flex items-center justify-center font-semibold">
                                            {(((totalClasses !== 0 ? (present / totalClasses) : (1))) * 100).toFixed(1)}%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                {(() => {
                                    const ab = skipable(present, totalClasses, crit);
                                    if (ab !== 0) {
                                        if ((present / totalClasses)*100 > crit) {
                                            return (
                                                <span className="inline-block text-sm mt-2">
                                                    Can skip <span className="bg-green-200 px-1 py-1 rounded">{ab} Class{ab>1?("es"):("")}</span>
                                                </span>
                                            );
                                        } else {
                                            return (
                                                <span className="inline-block text-sm mt-2">
                                                    Have to attend <span className="bg-red-400 px-1 py-1 text-white rounded">{ab} Class{ab>1?("es"):("")}</span>
                                                </span>
                                            );
                                        }
                                    }
                                    return null;
                                })()}
                            </div>

                        </div>
                    )
                })}

                {/* <h1>Attendance Summary</h1>
                    
                        const { name, totalClasses, present, absent } = attendanceData[subjectId];
                        return (
                            <div key={subjectId}>
                                <h2>{name}</h2>
                                <p>Total Classes: {totalClasses}</p>
                                <p>Present: {present}</p>
                                <p>Absent: {absent}</p>
                            </div>
                        ); */}
            </div>
        </div>
    )
}
